<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader :title="`${roleId ? 'Edit' : 'Add New'} Role (Operator, Engineer, Supervisor, Admin)`" />

    <div class="container">
      <div class="row py-3">
        <div class="col-md-3">
          <div class="form-group">
            <label for="roleId" class="custom-label">ID</label>
            <input id="roleId" type="text" class="form-control shadow-none custom-input"
              placeholder="This is autogenerated" readonly v-model="saveData.id">
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Title</label>
            <input id="assetTypeName" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.title">
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="form-group">
            <label class="custom-label">Role Type</label>
            <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
              v-model="saveData.roletypeid">
              <option v-for="roleType in roleTypes" :key="roleType.uuid" :value="roleType.uuid">{{ roleType.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-md-3 mb-3">
            <div class="form-group">
              <label class="custom-label">Operational Areas</label>
              <div class="custom-multiple-dropdown-wrapper">
                <select class="form-select form-control shadow-none custom-input custom-dropdown" id="autoSizingSelect"
                  v-model="saveData.oaname">
                  <option value="" disabled selected>Select Option</option> <!-- Placeholder option -->
                  <option v-for="OA in OAs" :key="OA.code" :value="OA.code">{{ OA.type }}</option>
                </select>
                <button @click="updateSelectedOAs(saveData.oaname)" class="multiple-dropdown-add-button">+</button>
              </div>
            </div>
          </div>

          <div class="col-md-9 mb-3 align-self-end custom-input">
            <div v-if="selectedOAs.length > 0" class="custom-multiple-dropdown-container">
              <div v-for="(OA, index) in selectedOAs" :key="index">
                <span class="custom-multiple-dropdown">{{ OA }}
                  <button class="multiple-dropdown-delete-icon" @click="removeSelectedOA(index)">
                    <dropdownDeleteIcon />
                  </button>
                </span>
              </div>
            </div>
          </div>
          <small v-if="selectedOAs.length === 0" class="text-danger" style="margin-top: -10px; font-size: 11px;">Select
            Opearational Area</small>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeDesc" class="custom-label">Description</label>
            <input id="assetTypeDesc" class="form-control shadow-none custom-input" placeholder="Enter text"
              v-model="saveData.description">
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" rows="4" placeholder="Enter text"
              v-model="saveData.note"></textarea>
          </div>
        </div>
        <div class="col-md-3" v-if="this.roleId">
          <div class="form-group">
            <button type="button" class="btn btn-danger btn-sm delete-button" data-bs-toggle="modal"
              data-bs-target="#exampleModal">Delete</button>
          </div>
        </div>

        <!-- Modal -->
        <deleteModal v-if="this.roleId" :deleteRecord="deleteRecord" />
        <div class="col-md-8 d-flex justify-content-end" v-if="this.roleId">

          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-11 d-flex justify-content-end" v-else>
          <div class="form-group">
            <button type="button" class="btn btn-secondary btn-sm cancel-button" @click="cancelButton()">Cancel</button>
          </div>
        </div>
        <div class="col-md-1 d-flex justify-content-start">
          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-sm submit-button" :disabled="isSubmitDisabled"
              @click="addRoleData()">Submit</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { addRole, getByIdRole, updateRole, ddOA, ddRoleType } from '@/http/user-mgmt/role.http'
import deleteModal from '@/components/delete-modal.vue';
import dropdownDeleteIcon from '@/components/dropdown-delete-icon.vue';
export default {
  name: 'role-form',
  components: {
    Header,
    Subheader,
    deleteModal,
    dropdownDeleteIcon
  },
  data() {
    return {
      // titleConfig:"Add Asset Type",
      roleId: this.$route.params.id,
      saveData: {
        oaname: ''
      },
      roleTypes: [],
      selectedOAs: [],
      OAs: [],
      breadcrumsfirst: "User Management",
      breadcrumslast: "Role",

    }
  },
  mounted() {
    this.getOADropdownData()
      .then(() => {
        return this.getDetailData();
      })
      .then(() => {
        this.getRoleTypeDropdownData();
      })
      .catch(error => {
        console.error('Error mounting component:', error);
      });
  },
  computed: {
    isSubmitDisabled() {
      return this.selectedOAs.length === 0;
    }
  },
  methods: {
    addRoleData() {
      const selectedOAIds = this.selectedOAs.map(OAName => {
        const OA = this.OAs.find(OA => OA.type === OAName);
        return OA ? OA.code : null;
      }).filter(Boolean).join(',');
      // Assign selected asset type IDs to saveData
      this.saveData.oaname = selectedOAIds;
      if (this.roleId) {
        const payload = {
          uuid: this.$route.params.id,
        };
        updateRole({ ...payload, ...this.saveData }).then(() => {
          this.saveData.updatedon = new Date().toISOString();
          this.$router.push("/usermanagement/role")
        }).catch((error) => {
          this.error = error.message;
        });
      } else {
        addRole(this.saveData).then(() => {
          this.$router.push("/usermanagement/role")
        }).catch((error) => {
          this.error = error.message;
        });
      }

    },
    async getDetailData() {
      try {
        if (this.roleId) {
          const response = await getByIdRole(this.roleId);
          this.saveData = response;
          this.saveData.roletypeid = response.roletypeid;

          if (Array.isArray(response.oaname) && response.oaname.length > 0) {
            this.selectedOAs = response.oaname.map(oaname => {
              const OA = this.OAs.find(type => type.code === oaname);
              return OA ? OA.type : '';
            });
            this.saveData.oaname = '';
          } else {
            this.saveData.oaname = '';
          }
        }
      } catch (error) {
        console.error('Error fetching asset details:', error);
        throw error;
      }
    },
    getRoleTypeDropdownData() {
      // Fetch assets
      ddRoleType()
        .then(response => {
          this.roleTypes = response;
          // Set default value for parentassetid
          if (this.roleTypes.length > 0) {
            // Check if assetId is set and update parentassetid accordingly
            if (this.roleId) {
              const index = this.roleTypes.findIndex(roleType => roleType.uuid === this.saveData.roletypeid);
              if (index !== -1) {
                this.saveData.roletypeid = this.roleTypes[index].uuid;
              }
            } else {
              this.saveData.roletypeid = this.roleTypes[0].uuid;
            }
          }
        })
        .catch(error => {
          console.error('Error fetching assets:', error);
        });
    },
    updateSelectedOAs(OAId) {
      const OA = this.OAs.find(OA => OA.code === OAId);
      if (OA && !this.selectedOAs.includes(OA.type)) {
        this.selectedOAs.push(OA.type);
      }
    },
    removeSelectedOA(index) {
      this.selectedOAs.splice(index, 1);
    },
    async getOADropdownData() {
      try {
        this.OAs = await ddOA();
      } catch (error) {
        console.error('Error fetching OA:', error);
        throw error;
      }
    },
    cancelButton() {
      this.$router.push("/usermanagement/role")
    },
    deleteRecord() {
      this.saveData.issoftdelete = 1;
      const payload = {
        issoftdelete: this.saveData.issoftdelete ? 1 : 0,
        uuid: this.$route.params.id,
      };
      updateRole({ ...payload, ...this.saveData }).then(() => {
        this.saveData.updatedon = new Date().toISOString();
        this.$router.push("/usermanagement/role")
      }).catch((error) => {
          this.error = error.message;
        });

    },

  }
}
</script>

<style scoped></style>